import type { Linter } from 'eslint'

export const nextRules: Linter.RulesRecord = {
  'react-refresh/only-export-components': 'off'
}
